module.exports = __webpack_public_path__ + "img/ja-deep-customer-empathy-thumbnail.4219898d.jpg";